import { Clear, Repeat } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";
import { useMemo, useState } from "react";
import { cancelBooking } from "../../redux/actions/apiActions";
import { showAlert } from "../../redux/actions/commonActions";
import { setShowLoginForm } from "../../redux/actions/authActions";
import moment from "moment-timezone";

const BookingCancel = () => {

    const [showDialog, setShowDialog] = useState(false);
    const userData = useSelector(state => state.auth.userData);
    const bookingDetails = useSelector(state => state.api.bookingDetails);
    const dispatch = useDispatch();

    const onCloseDialog = () => {
        setShowDialog(false);
    }
    const onConfirmDialog = () => {
        setShowDialog(false);
        if (bookingDetails?.id) {
            dispatch(cancelBooking(bookingDetails?.id));
        }
    }

    const handleButton = () => {
        const isAuthorisedUser = userData?.id &&
            (
                userData?.id === bookingDetails?.customerId ||
                userData?.email === bookingDetails?.customerEmail ||
                userData?.telephone === bookingDetails?.customerPhoneNumber
            );

        if (isAuthorisedUser) {
            setShowDialog(true)
        } else {
            if (userData?.id) {
                dispatch(showAlert("error", "You are not allowed to cancel this booking. Please login using Email/Phone number that used to book this appointment."))
            } else {
                dispatch(setShowLoginForm(true));
            }
        }
    }

        const isCancelAllowedNow = useMemo(
            () => {
                if (bookingDetails?.modificationAllowedUntil && moment().isAfter(moment.unix(bookingDetails?.modificationAllowedUntil))) {
                    return true;
                }
                return false;
            }, [bookingDetails]
        )
    

    return (
        <>
            <Button variant="outlined" sx={{ borderRadius: 5, gap: 1 }} onClick={handleButton} disabled={isCancelAllowedNow}>
                <Clear /> Cancel
            </Button>
            <ConfirmationDialog
                show={showDialog}
                title={<Typography variant="overline">Booking Cancellation</Typography>}
                content={`Do you want to cancel this booking? ${bookingDetails?.subBookings?.length ? " If you proceed, all associated sub-bookings will also be cancelled." : ""}`}
                onClose={onCloseDialog}
                onConfirm={onConfirmDialog}
                onCancel={onCloseDialog}
            />
        </>
    )
}

export default BookingCancel;